import Color from 'color';

export const getHexColor = (color: string | Color) => new Color(color).hex();
